var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"mb-12 mt-12 rounded",staticStyle:{"border-bottom":"1px solid #B7BDCD","background":"#EEEEEE","white-space":"nowrap"}},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,staticClass:"px-3 my-auto",class:[
        'custom-tab',
        tab.id === _vm.currentTab ? 'custom-tab__active' : 'custom-tab__inactive',
      ],staticStyle:{"display":"inline-block"},on:{"click":function($event){return _vm.$emit('current-tab', tab.id)}}},[_vm._v(" "+_vm._s(tab.value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }